import React from 'react';

import styled from '@emotion/styled';

interface GradientTextProps {
  children?: React.ReactNode;
}
const GradientText: React.FC<GradientTextProps> = ({ children }) => {
  return <TextStyles>{children}</TextStyles>;
};

export default GradientText;

const TextStyles = styled.span`
  /* background: linear-gradient(90deg, #ff8a00, #e52e71); */
  background: linear-gradient(
    262.94deg,
    #436db8 9.61%,
    #5b91f5 49.28%,
    #3c80ff 85.91%
  );

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;
